import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { templateParameterV1Schema } from './parameter';
import { templateReferenceV1Schema } from './reference';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateDateRangePickerSchema = templateNamedWidgetSchema.extend({
  type: z.literal('dateRangePicker'),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  value: z
    .object({
      from: z.string().nullable(),
      to: z.string().nullable(),
    })
    .nullable(),
  isRequired: z.boolean(),
  withTime: z.boolean(),
  placeholder: z.string(),
  defaultStartDayToday: z.boolean(),
  defaultNow: z.boolean(),
  disabledDateRule: z.enum(['none', 'lessThanToday', 'greaterThanTody']),
  parameter: templateParameterV1Schema.optional(),
  reference: templateReferenceV1Schema,
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
});

export type TemplateDateRangePickerV1 = z.infer<
  typeof templateDateRangePickerSchema
>;
